

















































import { AxiosPromise } from 'axios';
import Component, { mixins } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import UseBackend from '@/core/mixins/use-backend';
import { HUNTING_LICENSE_ORDERS } from '@/common/api';
import GisGmpSubscriptionPayment = Orders.GisGmpSubscriptionPayment;
import GisGmpSubscriptionPaymentSearchMode = Orders.GisGmpSubscriptionPaymentSearchMode;
import GisGmpSubscriptionPaymentsSearch = Orders.GisGmpSubscriptionPaymentsSearch;

const STATUS_LABELS: Record<string, string> = {
  '1': 'Новый',
  '2': 'Уточнение',
  '3': 'Аннулирование',
  '4': 'Деаннулирование',
};

const DISCLAIMERS: Record<GisGmpSubscriptionPaymentSearchMode, string> = {
  inn:
    'Поиск по ИНН заявителя (payerIdentifier). Показаны все платежи с этим идентификатором по подписке КБК — не только по этому заявлению. Привязка — решение оператора.',
  fio:
    'ИНН у заявителя нет — поиск по ФИО без учёта регистра. Возможны платежи однофамильцев и все платежи этого ФИО по КБК. Привязка — решение оператора.',
  none: 'Недостаточно данных заявителя для поиска (нет ИНН и ФИО).',
};

@Component({
  name: 'SubscriptionPayments',
})
export default class SubscriptionPayments extends mixins(UseBackend) {
  @Prop({ type: Number, required: true })
  orderId!: number;

  payments: GisGmpSubscriptionPayment[] = [];
  searchMode: GisGmpSubscriptionPaymentSearchMode = 'none';
  loading = false;

  columns = [
    { name: 'paymentDate', label: 'Дата платежа', field: 'paymentDate', align: 'left' as const },
    { name: 'amount', label: 'Сумма', field: 'amount', align: 'right' as const },
    { name: 'kbk', label: 'КБК', field: 'kbk', align: 'left' as const },
    { name: 'paymentId', label: 'УПНО', field: 'paymentId', align: 'left' as const },
    { name: 'payerName', label: 'Плательщик', field: 'payerName', align: 'left' as const },
    { name: 'purpose', label: 'Назначение', field: 'purpose', align: 'left' as const },
    {
      name: 'changeStatusMeaning',
      label: 'Статус',
      field: 'changeStatusMeaning',
      align: 'left' as const,
    },
  ];

  get disclaimer(): string {
    return DISCLAIMERS[this.searchMode] || DISCLAIMERS.none;
  }

  @Watch('orderId', { immediate: true })
  onOrderIdChange() {
    if (this.orderId) {
      this.load();
    }
  }

  statusLabel(code: string | null): string {
    if (!code) return '—';
    return STATUS_LABELS[code] || code;
  }

  async load() {
    this.loading = true;
    try {
      const endpoint = HUNTING_LICENSE_ORDERS.SUBSCRIPTION_PAYMENTS(this.orderId);
      const { data } = await this.makeRequest(
        () => this.$http(endpoint) as AxiosPromise<GisGmpSubscriptionPaymentsSearch>
      );
      this.payments = data?.payments || [];
      this.searchMode = data?.searchMode || 'none';
    } catch (e) {
      this.payments = [];
      this.searchMode = 'none';
    } finally {
      this.loading = false;
    }
  }
}
